{
    "Profile_Drivers_Driver.name": "Name",
    "Profile_Drivers_Driver.person": "Person",
    "Profile_Drivers_Driver.driverDetails": "Driver Details",
    "Profile_Drivers_Driver.number": "Number",
    "Profile_Drivers_Driver.applicant": "Applicant",
    "Profile_Drivers_Driver.relationshipToApplicant": "Relationship to Applicant",
    "Profile_Drivers_Driver.yearsContinuouslyInsured": "Years Continuously Insured",
    "Profile_Drivers_Driver.yearsWithPreviousInsurer": "Years With Previous Insurer",
    "Profile_Drivers_Driver.yearsAtCurrentAddress": "Years at Current Address",
    "Profile_Drivers_Driver.driverTraining": "Driver Training",
    "Profile_Drivers_Driver.outOfCountryExperience": "Out of Country Experience",
    "Profile_Drivers_Driver.numberOfClaims": "Number of Claims",
    "Profile_Drivers_Driver.timeframeOfClaims": "Timeframe of Claims",
    "Profile_Drivers_Driver.licenseDetails": "License Details",
    "Profile_Drivers_Driver.ageFirstLicensed": "Age First Licensed",
    "Profile_Drivers_Driver.issuingCountry": "Issuing Country",
    "Profile_Drivers_Driver.issuingProvince": "Issuing Province",
    "Profile_Drivers_Driver.licenseNumber": "License Number",
    "Profile_Drivers_Driver.licenseClass": "License Class",
    "Profile_Drivers_Driver.issuedDate": "Issued Date",
    "Profile_Drivers_Driver.numberOfConvictions": "Number of Convictions",
    "Profile_Drivers_Driver.timeframeOfConvictions": "Timeframe of Convictions",
    "Profile_Drivers_Driver.drivingConvictions": "Driving Convictions",
    "Profile_Drivers_Driver.drivingSuspensions": "Driving Suspensions",
    "Profile_Drivers_Driver.criminalConvictions": "Criminal Convictions",
    "Profile_Drivers_Driver.claims": "Claims",
    "Profile_Drivers_Driver.cancellations": "Cancellations",
    "Profile_Drivers_Driver.newConviction": "New Conviction",
    "Profile_Drivers_Driver.newSuspension": "New Suspension",
    "Profile_Drivers_Driver.newCriminalConviction": "New Criminal Conviction",
    "Profile_Drivers_Driver.newClaim": "New Claim",
    "Profile_Drivers_Driver.newCancellationReason": "New Cancellation Reason",
    "Profile_Drivers_Driver.state": "State"
}
